import { render } from "./FooterContentView.vue?vue&type=template&id=d0783716&scoped=true"
import script from "./FooterContentView.vue?vue&type=script&lang=js"
export * from "./FooterContentView.vue?vue&type=script&lang=js"

import "./FooterContentView.vue?vue&type=style&index=0&id=d0783716&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/sms-166dx-web-frontend-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0783716"]])

export default __exports__